import React from 'react';
import { Grid } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { FastField } from 'formik';

import { addendumFile } from '../../../../actionTypes';
import AddendumFileUploaderInput from '../../../components/AddendumFileUploaderInput';
import { fileAddendumUploadUrl } from '../../../../utils/constants';

const FileType = ({ name, label, readOnly, companyId }) => {
  const dispatch = useDispatch();

  const handleDownload = (fileId, fileName) => {
    dispatch({
      type: addendumFile.download.start,
      payload: {
        companyId,
        fileId,
        fileName,
      },
    });
  };

  return (
    <Grid container spacing={1} justify="space-between" alignItems="center">
      <Grid item xs={12}>
        <FastField
          name={`${name}.files`}
          component={AddendumFileUploaderInput}
          label={label}
          companyId={companyId}
          handleDownload={handleDownload}
          uploadUrl={fileAddendumUploadUrl}
          disabled={readOnly}
          editable={!readOnly}
        />
      </Grid>
    </Grid>
  );
};

export default FileType;
